import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import type { LocaleType } from '@/models/common/locale';

export type LocaleContextType = {
  locale: LocaleType;
  setLocale: (lang: LocaleType) => void;
};

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export const LocaleProvider = ({
  children,
  locale,
}: {
  children: ReactNode;
  locale: LocaleType;
}) => {
  const [currentLocale, setCurrentLocale] = useState(locale);

  useEffect(() => {
    setCurrentLocale(locale);
  }, [locale]);

  const value = useMemo(
    () => ({ locale: currentLocale, setLocale: setCurrentLocale }),
    [currentLocale],
  );

  return <LocaleContext value={value}>{children}</LocaleContext>;
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context)
    throw new Error('useLocale must be used within a LocaleProvider');
  return context;
};
